import { useContext } from "react";
import { LayerContext } from "../LayerContext";
import { OsmPoiInfo } from "../../../../types/LayerAdmin/OsmPoiInfo";
import SortableTable from "../../../Table/SortableTable";
import {
  TableColumn,
  TableDataType,
} from "../../../../types/Table/TableColumns";

const GeoFabrikReport = () => {
  const value = useContext(LayerContext);
  const { layerInfo } = value!;
  const osmPoiInfo = layerInfo as OsmPoiInfo;

  const cols = [
    { displayName: "Source", field: "id", sortable: true },
    { displayName: "Url", field: "url", dataType: TableDataType.LINK },
  ] as TableColumn[];

  return (
    <SortableTable data={osmPoiInfo.missingGeofabrikSources} columns={cols} />
  );
};

export default GeoFabrikReport;
